import { useState } from "react";
import liff from "@line/liff";

const useResetMemory = (canReset, isExpired = false) => {
  const [openConfirm, setOpenConfirm] = useState(false);
  const [openNotice, setOpenNotice] = useState(false);
  const [openExpiredNotice, setOpenExpiredNotice] = useState(false);
  const [openError, setOpenError] = useState(false);

  const onClickConfirm = async () => {
    try {
      setOpenConfirm(false);
      const messageText = "**reset**";
      liff.sendMessages([{ type: "text", text: messageText }]);
      liff.closeWindow();
    } catch (error) {
      setOpenError(true);
    }
  };

  const onClickReset = () => {
    if (isExpired) {
      setOpenExpiredNotice(true);
      return;
    }

    if (canReset) {
      setOpenConfirm(true);
    } else {
      setOpenNotice(true);
    }
  };

  const onClickClose = () => {
    setOpenConfirm(false);
    setOpenNotice(false);
    setOpenExpiredNotice(false);
    setOpenError(false);
  };

  return {
    dialogStates: {
      openConfirm,
      openNotice,
      openExpiredNotice,
      openError,
    },
    handlers: {
      onClickReset,
      onClickConfirm,
      onClickClose,
    },
  };
};

export default useResetMemory;
